import _objectSpread from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import PageFooter from '@/layouts/footer/PageFooter';
import { mapState } from 'vuex';
export default {
  name: 'CommonLayout',
  components: {
    PageFooter: PageFooter
  },
  computed: _objectSpread({}, mapState('setting', ['footerLinks', 'copyright']))
};